import commonMixin from '../../../mixins/_common';
import flashMessageMixin from '../../../mixins/_flash_messages';

// 地域定義
const AREAS = [
    'hokkaido',
    'north_tohoku',
    'south_tohoku',
    'kanto',
    'shinetsu',
    'hokuriku',
    'tyubu',
    'kansai',
    'tyugoku',
    'shikoku',
    'kyusyu',
    'okinawa',
];
// 未選択時の初期送料、初期お届け日
const DEFAULT_POSTAGE = null;
const DEFAULT_DELIVERY_DATE = null;
// 送料タイプ定義
const ABOUT_POSTAGE_TBL_TYPES = {
    // 全国一律送料
    ALL: 1,
    // 都道府県別送料
    SEPARATE: 2,
};

/**
 * 新しく配送方法を追加する時の配送方法テンプレート選択コンポーネント
 */
export default {
    name: 'DeliveryTemplateSelecter',
    template: '#delivery_template_selecter_template',
    data() {
        // コンポーネント固有のデータ
        return {
            // テンプレートデータを指定するための指定配送業者、配送種類
            delivery_company: null,
            delivery_type: null,

            // 発送データテンプレート
            template: {},
            // 全国一律送料の選択肢のみ表示フラグ
            is_only_about_postage_tbl_type_all: false,

            // 公式送料リンク用名前とリンク
            template_name: null,
            official_shipping_info_page: null,

            // お届け日定義
            delivery_dates: {},
            // 送料定義
            shippings: null,

            // 送料、お届け日定義を絞り込むための指定された発地、サイズ
            // セレクト用データ
            sizes: [],
            // 選択された値
            select_prefecture: null,
            select_size: null,
        };
    },
    props: {
        // 設定No(index + 1)
        no: {
            type: Number,
            required: true
        },
        // 配送データ一覧(設定名重複防止に使う)
        configs: {
            type: Array,
            required: true
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    /**
     * 算出プロパティ
     */
    computed: {
        // 現在のステップ番号を返す
        step: {
            get: function () {
                if (this.delivery_type && this.hasTemplate) {
                    return 3;
                }
                if (this.delivery_company) {
                    return 2;
                }
                return 1;
            },
            set: function (value) {
                if (value < 3) {
                    this.delivery_type = null;
                    this.template = {};
                }
                if (value < 2) {
                    this.delivery_company = null;
                }
                // その他の配送方法が増えたら削除
                if (this.delivery_company === 'other') {
                    this.delivery_company = null;
                }
            }
        },
        // 選択された発地の値から"|{都道府県code}"を除く(ユニークにしないとセレクトの挙動が安定しない為、都道府県codeを付与している)
        selectPrefecture: function () {
            if (this.select_prefecture === null) {
                return null;
            }
            return this.select_prefecture.replace(/\|.*/, '');
        },
        // テンプレートデータがあるか
        hasTemplate: function () {
            return (Object.keys(this.template).length > 0);
        },
        // 発地が指定されたお届け予定日
        deliveryDaySettingsPrefectures: function () {
            let deliveryDate = {};
            for (let area of AREAS) {
                // お届け日
                let deliveryDay = DEFAULT_DELIVERY_DATE; // 未指定の初期値
                if (this.delivery_dates !== null && typeof this.delivery_dates[this.selectPrefecture] !== 'undefined') {
                    deliveryDay = this.delivery_dates[this.selectPrefecture][area];
                }
                deliveryDate[area] = {
                    delivery_day: deliveryDay
                };
            }
            return deliveryDate;
        },
        // 送料タイプが一律か(objectだったら都道府県別)
        isAboutPostageTblTypeAll: function () {
            return !this.$_isObject(this.shippings);
        },
        // 送料
        aboutPostageTblSettings: function () {
            let shipping = {
                about_postage_tbl_type: this.template.about_postage_tbl_settings.about_postage_tbl_type,
                postage: DEFAULT_POSTAGE,
                prefectures: {},
                remote_island_other_postage: this.template.about_postage_tbl_settings.remote_island_other_postage,
            };
            // 全国一律の送料
            if (this.template.about_postage_tbl_settings.about_postage_tbl_type === ABOUT_POSTAGE_TBL_TYPES.ALL) {
                if (this.isAboutPostageTblTypeAll && this.shippings) {
                    shipping.postage = this.shippings;
                }
                if (this.hasTemplate && this.template.about_postage_tbl_settings.postage !== null) {
                    shipping.postage = this.template.about_postage_tbl_settings.postage;
                }
            }

            // 都道府県別の送料
            for (let area of AREAS) {
                shipping.prefectures[area] = {
                    postage: this.getAreaShipping(area)
                };
            }
            return shipping;
        },
        // テンプレート適用ボタンが押せる状態か
        canCnvert: function () {
            // 都道府県別送料はサイズ、発地の選択がされていないと不可
            if (this.template.about_postage_tbl_settings.about_postage_tbl_type === ABOUT_POSTAGE_TBL_TYPES.SEPARATE) {
                if (!this.isAboutPostageTblTypeAll && !this.selectPrefecture)  {
                    return false;
                }
                if (this.sizes && !this.select_size)  {
                    return false;
                }
            } else {
                if (this.template.about_postage_tbl_settings.postage === null || this.template.about_postage_tbl_settings.postage === '') {
                    return false;
                }
            }
            return true;
        },
    },
    watch: {
        // 各業者の発送方法が更新されたらテンプレートデータ取得
        delivery_type: function (newValue) {
            if (newValue) {
                this.getShippingTemplate(this.delivery_company, this.delivery_type);
            }
        },
        // その他の配送方法選択時は送料計算画面をスキップ
        step: function (step) {
            if (step === 3 && this.delivery_company === 'other') {
                this.convert();
                // 確認画面から戻った時step1になるようにしておく
                this.step = 1;
            }
        }
    },
    emits: [
        'create-data',
        'template-key',
    ],
    methods: {
        // 指定の地域の送料を取得
        getAreaShipping (area) {
            // 送料タイプを一律で指定していたらデフォルトを返す
            if (this.template.about_postage_tbl_settings.about_postage_tbl_type === ABOUT_POSTAGE_TBL_TYPES.ALL) {
                return DEFAULT_POSTAGE;
            }
            // テンプレートが送料一律タイプだったらデフォルトを返す
            if (this.isAboutPostageTblTypeAll) {
                return DEFAULT_POSTAGE;
            }
            // 発地未選択時は初期値
            if (this.selectPrefecture === null) {
                return DEFAULT_POSTAGE;
            }

            const areaShipping = this.shippings[this.selectPrefecture][area];
            // objectでなければサイズ定義なし
            if (!this.$_isObject(areaShipping)) {
                return areaShipping;
            }
            // サイズ未選択時は初期値
            if (this.select_size === null) {
                return DEFAULT_POSTAGE;
            }
            // 指定サイズ別送料
            return areaShipping[this.select_size];
        },
        // 指定配送方法のテンプレートデータを取得
        async getShippingTemplate (company, type) {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/setup/delivery/get_shipping_template', {
                    _method: 'GET',
                    company: company,
                    type: type
                });
                if (response.data.status === 'OK') {
                    this.template = response.data.message.template.data;
                    this.template_name = response.data.message.template.name;
                    this.official_shipping_info_page = response.data.message.template.official_shipping_info_page;
                    this.is_only_about_postage_tbl_type_all = (this.template.about_postage_tbl_settings.about_postage_tbl_type === 1);
                    this.sizes = response.data.message.sizes;
                    this.delivery_dates = response.data.message.delivery_dates;
                    this.select_prefecture = response.data.message.select_prefecture;
                    this.shippings = response.data.message.shippings;
                    // 一律送料指定の場合はここでthis.shippingsから代入させる
                    if (this.isAboutPostageTblTypeAll && this.shippings) {
                        this.template.about_postage_tbl_settings.postage = this.shippings;
                    }
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
        // 設定名を既存設定と重複しないように生成
        createPostageName: function () {
            let count = 0;
            for (let config of this.configs) {
                let match = config.postage.match(new RegExp(this.template.postage + '([0-9]{1,2}|$)'));
                if (match) {
                    // 同名があったら+1
                    if (!match[1] && count === 0) {
                        count = 1;
                    // 同名{数字}があり、現状以上だったら{数字}+1
                    } else if (match[1] && count <= Number(match[1])) {
                        count = Number(match[1]) + 1;
                    }
                }
            }
            // カウントがあったら設定名の末尾に付与
            if (count > 0) {
                return this.template.postage + count;
            }
            return this.template.postage;
        },
        // 計算後の送料をセットした最終的なデータを生成する
        convert: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (typeof event !== 'undefined') {
                if (!event?.target?.form?.checkValidity()) {
                    return;
                }
                event.preventDefault();
            }
            // 送料、お届け日を代入
            let data = this.template;
            data.no = this.no;
            data.postage = this.createPostageName();
            data.about_postage_tbl_settings = this.aboutPostageTblSettings;
            data.delivery_day_settings.prefectures = this.deliveryDaySettingsPrefectures;
            console.log('convert');
            console.log(data);
            // 親コンポーネントにデータを送る
            this.emitCreateData(data);
            this.emitTemplateKey();
        },

        // -------------------------
        // emit
        // -------------------------

        // 新しく作ったデータを送る
        emitCreateData: function (data) {
            this.$emit('create-data', data);
        },
        // 親画面で表示出し分け判定に使う為、選択したテンプレートキー(配送業者キー)を送る
        emitTemplateKey: function () {
            this.$emit('template-key', this.delivery_company);
        },
    }
};
